/**
 * @file     nav.ts
 * @readme   ../../CLAUDE.md
 * @purpose  English strings for navigation: category labels, page links, and aria labels.
 */
export const nav = {
  // ─── New Components (added 2026-03-15) ───────────────────────────
  title: 'Navigation',
  categories: {
    buy: 'Buy',
    rent: 'Rent',
    sell: 'Sell',
    data: 'Market data',
    learn: 'Learn',
    tools: 'Tools',
    blog: 'Blog',
    about: 'About'
  },
  actions: {
    findHomes: 'Find homes',
    openHomeFinder: 'Find homes: open the home finder',
    signIn: 'Sign in',
    account: 'Account',
    primary: 'Primary',
    menuTitle: 'Menu',
    brandHome: 'Relta home',
    switchToDark: 'Switch to dark mode',
    switchToLight: 'Switch to light mode'
  },
  items: {
    firstTimeBuyerGuide: 'First-time buyer guide',
    condoBuyingVancouver: 'Condo buying in Vancouver',
    movingToVancouver: 'Moving to Vancouver',
    sellMyHomeVancouver: 'Selling your home in Vancouver',
    shouldISellNow: 'Should you sell now?',
    findTenants: 'Find tenants',
    findRental: 'Find a rental',
    rentOutYourPlace: 'Rent out your place',
    marketUpdate: 'Market update',
    rentVsBuy: 'Rent vs buy',
    neighborhoodGuides: 'Neighbourhood guides',
    dealFinder: 'Property match',
    homeValue: 'Get property value',
    compare: 'Compare',
    smartMatch: 'Similar homes',
    propertyFinder: 'Home finder',
    mortgageCalculator: 'Mortgage calculator',
    startMySearch: 'Get a shortlist',
    hotDeals: 'Homes scored on price',
    presales: 'Presales in BC',
    affordability: 'What you can afford',
    rentVsMortgage: 'Rent vs mortgage',
    shortTermRentalHomes: 'Short-term rentals',
    mortgagePreApproval: 'Mortgage pre-approval',
    costOfBuying: 'Cost of buying',
    bcPropertyTaxes: 'BC property taxes',
    propertyTransferTaxCalculator: 'Property transfer tax calculator',
    gstNewHomeRebate: 'GST on new homes',
    closingCosts: 'Closing costs',
    bcHomeFlippingTax: 'Home flipping tax',
    speculationVacancyTax: 'Speculation and vacancy tax',
    homeWorth: 'What is my home worth',
    recentlySold: 'Recently sold',
    bestTimeToSell: 'When to sell',
    marketReport: 'Market reports',
    homesByCity: 'Homes by city',
    marketSignals: 'Market signals',
    buildings: 'Buildings',
    depreciationReport: 'Depreciation reports',
    viewMyMatches: 'View dashboard',
    getPropertyValue: 'Get property value',
    firstTimeBuyerPrograms: 'First-time buyer programs',
    academy: 'Learn about BC real estate',
    academyBuyer: 'Buyer course',
    academySeller: 'Seller course',
    academyLandlord: 'Landlord course',
    blog: 'Market journal',
    aboutRay: 'About',
    contact: 'Contact',
    marketInsight: 'Market insights'
  }
} as const;
